import {Component} from '@angular/core';
import {NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router} from '@angular/router';
import {StorageService} from '../provider/storage/storage.service';
import {APP_ROUTES, IQAPI_ROUTES} from '../../environments/environment';
import {tap} from 'rxjs/operators';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {ConfigurationObject} from '../interfaces/interfaces.regisafe';
import {AppConfig} from '../app.config';
import {UserService} from '../provider/user/user.service';
import {ALERT_TXT} from '../strings/language';

@Component({
	selector: 'app-regisafe',
	templateUrl: 'regisafe.page.html',
	styleUrls: ['regisafe.page.scss']
})
export class RegisafePage {

	public configuration: ConfigurationObject;

	affected: boolean;
	currentTab: string;

	constructor(private router: Router,
				private storageService: StorageService,
				public appConfig: AppConfig,
				private httpClient: HttpClient,
				private userService: UserService) {
		this.router.events.subscribe((event: any) => {

			switch (true) {
				case event instanceof NavigationEnd: {
					const path = this.router.url;
					this.handleVisibilityNavigationBar(path);

					break;
				}

				case event instanceof NavigationStart: {
					break;
				}
				case event instanceof NavigationCancel:
				case event instanceof NavigationError: {
					break;
				}

				default: {
					break;
				}
			}
		});

		this.configuration = this.appConfig.getConfig();
	}

	handleVisibilityNavigationBar(routerURL: string,) {
		const affectedRoutes = ['/regisafe/anmeldung', '/regisafe/abmeldung'];
		this.affected = affectedRoutes.includes(routerURL);
	}

	setCurrentTab(event) {
		this.currentTab = event.tab;
	}

	async logout() {
		const filesInProcess = await this.userService.checkFilesInProcess(false);
		let logout;
		if (filesInProcess) {
			logout = await this.userService.askForLogout(
				ALERT_TXT.header.str00010,
				ALERT_TXT.subHeader.str00140,
				ALERT_TXT.buttons.str00010);
		} else {
			logout = await this.userService.askForLogout(
				ALERT_TXT.header.str00010,
				ALERT_TXT.subHeader.str00130,
				ALERT_TXT.buttons.str00010);
		}

		if (logout.role === 'cancel') {
			return false;
		} else if (logout.role === 'logout') {
			this.sessionLogout();
		}

	}

	sessionLogout() {
		const accountData = {
			apiID: this.configuration.iqapiAppId,
			sessionToken: this.storageService.getToken() || '123'
		};
		const options: object = {headers: {}, responseType: 'json', reportProgress: true, observe: 'response'};
		this.httpClient
			.post(this.configuration.iqapiEndpoint + IQAPI_ROUTES.logout, accountData, options)
			.pipe(tap((res: HttpResponse<any>) => {
				// SessionToken aus Datenbank löschen
				this.storageService.removeToken();
			}))
			.subscribe((data: HttpResponse<any>) => {
				// Weiterleitung zur Anmeldung
				this.router.navigateByUrl(APP_ROUTES.anmeldung);
			}, (error) => {
				// Fehlerfall ignorieren, ggf. vorhandenen Token löschen und Weiterleitung zur Anmeldung
				this.storageService.removeToken();
				this.router.navigate([APP_ROUTES.anmeldung]);
			});
	}

}
